import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@material-ui/core'
import FileUpload from '../../../components/FileUpload'
import { getProductAssetsForProduct } from '../../../actions/UploadActions'
import { connect } from 'react-redux'

class ProductAssetModal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
        }
    }

    onClose = () => {
        this.setState({ open: false })
    }
    toggle = () => this.setState({ open: !this.state.open })
    open = () => this.setState({ open: true })

    onUpload = () => {
        if (this.props.onUpload) {
            this.props.onUpload()
        }
        // const { sku } = this.props
        // this.props.getProductAssets(sku)
    }

    render() {
        return (
            <div>
                <Button variant="contained" color="primary" onClick={this.open}>
                    Dodaj
                </Button>
                <Dialog onClose={this.onClose} open={this.state.open} fullWidth>
                    <DialogTitle>Upload</DialogTitle>
                    <DialogContent>
                        <FileUpload
                            onUpload={this.onUpload}
                            uploading={this.props.uploading}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.onClose}
                            variant="contained"
                            color="secondary"
                        >
                            Zamknij
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = ({ presto }) => {
    return {
        uploading: presto.upload.uploading,
    }
}

export default connect(mapStateToProps, {
    getProductAssets: getProductAssetsForProduct,
})(ProductAssetModal)
